module.exports = __webpack_public_path__ + "static/img/yewu.71f4bf6c.png";